import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	padding: 16px 32px 0 32px;
	flex-direction: column;
	overflow: auto;
`;

export const FormGroup = styled.div`
	margin-bottom: 32px;

	&:last-child {
		margin-bottom: 16px;
	}
`;

export const TimePeriodGroup = styled.div`
	margin-bottom: 29px;

	.ap-month-picker {
		> div:first-child {
			border-radius: 0;
			border-color: ${colors.grey4};
			height: 40px;
			font-size: 16px;
			color: ${colors.grey8};
			padding: 0 32px 0 10px;

			&:hover {
				border-color: ${colors.green2};
			}
		}

		> div:nth-child(2) {
			top: 10px;
		}
	}
`;

export const Label = styled.div`
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey5};
	padding-bottom: 4px;
`;

export const DropdownWrapper = styled.div`
	width: 480px;
`;

export const HorizontalGroup = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 0 6px 8px;

	> label {
		margin-right: 32px;
	}
`;

export const RadioLabel = styled.div`
	font-size: 16px;
	line-height: 24px;
	color: ${colors.grey8};
	padding-left: 3px;

	${({ disabled }) => disabled && `color: ${colors.grey5};`};
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const MonthPickerWrapper = styled.div`
	display: flex;
`;

export const Description = styled.div`
	padding-top: 11px;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	width: 645px;

	span {
		color: ${colors.green1};
		cursor: pointer;

		&:hover {
			color: ${colors.green2};
		}
	}
`;

export const SelectorWrapper = styled.div`
	padding: 0 16px 0 32px;
	border-left: 1px solid ${colors.grey3};
	width: 280px;
`;
